import { gql } from '@apollo/client';

/**
 * Editing one person on their page (card 21.5): CRM_CONTACT_QUERY_FRONTEND.md §26.
 *
 * Every mutation answers with the contact; these ask only for its id, and the
 * page refetches itself and its timeline (forgetEditData), as the do-not-call
 * banner does. Each change is logged by the API and shows on the timeline.
 */

export const CRM_UPDATE_CONTACT = gql`
  mutation CrmUpdateContact($id: Int!, $change: CrmContactDetailsInput!) {
    crmUpdateContact(id: $id, change: $change) {
      id
    }
  }
`;

export const CRM_ADD_CONTACT_EMAIL = gql`
  mutation CrmAddContactEmail($contactId: Int!, $email: String!, $makePrimary: Boolean) {
    crmAddContactEmail(contactId: $contactId, email: $email, makePrimary: $makePrimary) {
      id
    }
  }
`;

export const CRM_UPDATE_CONTACT_EMAIL = gql`
  mutation CrmUpdateContactEmail($contactId: Int!, $emailId: Int, $change: CrmContactEmailChange!) {
    crmUpdateContactEmail(contactId: $contactId, emailId: $emailId, change: $change) {
      id
    }
  }
`;

export const CRM_REMOVE_CONTACT_EMAIL = gql`
  mutation CrmRemoveContactEmail($contactId: Int!, $emailId: Int!) {
    crmRemoveContactEmail(contactId: $contactId, emailId: $emailId) {
      id
    }
  }
`;

export const CRM_ADD_CONTACT_PHONE = gql`
  mutation CrmAddContactPhone($contactId: Int!, $type: PhoneType!, $number: String!, $makePrimary: Boolean) {
    crmAddContactPhone(contactId: $contactId, type: $type, number: $number, makePrimary: $makePrimary) {
      id
    }
  }
`;

export const CRM_UPDATE_CONTACT_PHONE = gql`
  mutation CrmUpdateContactPhone($contactId: Int!, $phoneId: Int, $change: CrmContactPhoneChange!) {
    crmUpdateContactPhone(contactId: $contactId, phoneId: $phoneId, change: $change) {
      id
    }
  }
`;

export const CRM_REMOVE_CONTACT_PHONE = gql`
  mutation CrmRemoveContactPhone($contactId: Int!, $phoneId: Int!) {
    crmRemoveContactPhone(contactId: $contactId, phoneId: $phoneId) {
      id
    }
  }
`;

export const CRM_ADD_CONTACT_ADDRESS = gql`
  mutation CrmAddContactAddress($contactId: Int!, $address: CrmContactAddressInput!, $makePrimary: Boolean, $usePlace: Boolean) {
    crmAddContactAddress(contactId: $contactId, address: $address, makePrimary: $makePrimary, usePlace: $usePlace) {
      id
    }
  }
`;

export const CRM_UPDATE_CONTACT_ADDRESS = gql`
  mutation CrmUpdateContactAddress($contactId: Int!, $addressId: Int!, $change: CrmContactAddressChange!) {
    crmUpdateContactAddress(contactId: $contactId, addressId: $addressId, change: $change) {
      id
    }
  }
`;

export const CRM_REMOVE_CONTACT_ADDRESS = gql`
  mutation CrmRemoveContactAddress($contactId: Int!, $addressId: Int!) {
    crmRemoveContactAddress(contactId: $contactId, addressId: $addressId) {
      id
    }
  }
`;

export const CRM_ADD_CONTACT_NOTE = gql`
  mutation CrmAddContactNote($contactId: Int!, $body: String!) {
    crmAddContactNote(contactId: $contactId, body: $body) {
      id
    }
  }
`;

export const CRM_UPDATE_CONTACT_NOTE = gql`
  mutation CrmUpdateContactNote($noteId: Int!, $body: String!) {
    crmUpdateContactNote(noteId: $noteId, body: $body) {
      id
    }
  }
`;

export const CRM_DELETE_CONTACT_NOTE = gql`
  mutation CrmDeleteContactNote($noteId: Int!) {
    crmDeleteContactNote(noteId: $noteId) {
      id
    }
  }
`;
